"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkLoyaltyDialogResultAndAddToBasketHandler = checkLoyaltyDialogResultAndAddToBasketHandler;
var AddToBasket = _interopRequireWildcard(require("@ori-events/add-to-basket"));
var LoyaltyDialogResult = _interopRequireWildcard(require("@ori-events/loyalty-dialog-result"));
var _types = require("../types");
var _utils = require("../utils");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
async function checkLoyaltyDialogResultAndAddToBasketHandler({
  detail
}) {
  const {
    result
  } = detail;
  if (LoyaltyDialogResult.isLoyaltyCloseResult(result)) {
    return false;
  }
  if (LoyaltyDialogResult.isLoyaltyBuyForPointsResult(result)) {
    const {
      catalogueItemId,
      choiceId,
      itemCode,
      quantity,
      placement
    } = detail;
    return (0, _utils.addToBasket)(_types.RequestUrl.AddToBasketForPoints, {
      itemCode,
      quantity,
      choiceId,
      catalogueItemId,
      placement
    }, AddToBasket.Method.BUY_FOR_POINTS);
  }
  if (LoyaltyDialogResult.isLoyaltyBuyForMoneyResult(result)) {
    const {
      itemCode,
      quantity,
      originalItemCode,
      replacementType,
      placement
    } = detail;
    return (0, _utils.addToBasket)(_types.RequestUrl.AddToBasketForMoney, {
      itemCode,
      quantity,
      originalItemCode,
      replacementType,
      placement
    }, AddToBasket.Method.BUY_FOR_MONEY);
  }
  return false;
}
